import { online_ordering_video_id } from 'src/consts/resource';
const SectionContent = {
  topSection: {
    en: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_pos_online-ordering.jpeg`,
      title: 'Online Ordering for Restaurants',
      description: 'Take orders from your own website, the most profitable order source. ',
      youtubeVideoId: online_ordering_video_id.en,
    },
    zh: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_pos_online-ordering.jpeg`,
      title: '餐馆线上点餐系统，具备网页支付能力，免佣金',
      description: '在您的网站上直接接外卖订单和到店自取订单',
      youtubeVideoId: online_ordering_video_id.zh,
    },
  },
  advances: {
    en: {
      title: `Chowbus Online Ordering for Restaurants`,
      subTitle: ` A restaurant online ordering system that allows guests to order takeout and delivery directly from you.`,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_online-ordering_feature_1.png`,
          imageAlt: 'Your Own Brand',
          title: 'Your Own Brand',
          description: 'We offer White Label products you can customize with you own logo and brand',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_online-ordering_feature_2.png`,
          imageAlt: 'We Deliver',
          title: 'We Deliver',
          description: 'Chowbus handles delivery so you don’t have to worry',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_online-ordering_feature_3.png`,
          imageAlt: 'Commission-free',
          title: 'Commission-free',
          description: 'No commissions. Only a monthly fee and small fee per order',
        },
      ],
    },
    zh: {
      title: `Chowbus网页支付系统`,
      subTitle: ` 在您的网站上接收订单 - 就是这么简单`,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_online-ordering_feature_1.png`,
          imageAlt: '定制化设计',
          title: '定制化设计',
          description: '为您定制餐厅订餐网页设计，提升品牌形象并拓宽订单来源',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_online-ordering_feature_2.png`,
          imageAlt: '无忧送餐',
          title: '无忧送餐',
          description: '我们提供送餐司机，无需考虑配送问题',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_online-ordering_feature_3.png`,
          imageAlt: '透明零佣金',
          title: '透明零佣金',
          description: 'Chowbus不收取佣金，订餐网页的全部收入直接打到餐厅账户',
        },
      ],
    },
  },

  features: {
    en: {
      title: '',
      desc: ``,
      items: [
        {
          layout: 'row',
          direction: 'reverse',
          title: 'Make your website the most profitable order source.',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_online-ordering_advance_1.png`,
          items: [
            { desc: 'Best-in-Class Diner Browsing Experience: Slick design and easy diner ordering experience.' },
            { desc: 'Optimized for Both Desktop and Mobile: Increase sales with features like menu photos.' },
            {
              desc: ' For Your waitstaff - Fully Integrated into POS: Send all website orders directly to the POS and kitchen directly, saving you time, labor, and unnecessary hassle.',
            },
            {
              desc: 'Worry-free with Chowbus drivers: No drivers? No worries, we can provide drivers in 25 cities we operate for a small per order fee',
            },
          ],
        },

        {
          layout: 'row',
          direction: 'noraml',
          title: `No landing website? We’ll help you build one.
Do what you do best, let us do the rest.`,
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_online-ordering_advance_2.png`,
          items: [],
        },
      ],
    },
    zh: {
      title: '',
      desc: '',
      items: [
        {
          layout: 'row',
          direction: 'reverse',
          title: '让您的网站成为最赚钱的订单来源',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_online-ordering_advance_1.png`,
          items: [
            {
              desc: '我们提供网页设计服务：无需担心没有餐厅官网无法线上接单，我们提供专业的网站搭建及网页定制化设计等服务。',
            },
            { desc: '我们提供餐品配送服务：作为头部外卖公司，我们在美国23个城市提供送餐服务，送餐有保障' },
            {
              desc: '我们提供全套的POS系统：Chowbus网页支付系统集成Chowbus POS系统，订餐网页一键使用电子菜单，且所有订单都自动发送至POS APP和厨房，无需投入更多的人力',
            },
          ],
        },
        {
          layout: 'row',
          direction: 'noraml',
          title: `没有登陆网站？我们帮您建立一个！
                    做您最擅长的, 剩下的交给我们！`,
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_online-ordering_advance_2.png`,
          items: [],
        },
      ],
    },
  },
  whyNotChooseChowBus: {
    en: {
      title: 'Why Restaurants Choose Chowbus',
    },
    zh: {
      title: '他们选择Chowbus网页支付系统的原因',
    },
  },
  customerVoiceInfos: [
    {
      img: `${process.env.ASSETS_PREFIX}/home/customervoice/customer-voice-shinyaramen_2.jpeg`,
      productLine: 'QR Code',
      desc: {
        zh: `通过使用无接触点餐, 深夜食堂的翻桌率提高了 30%, 并减少了三个人工. “我们的一些服务员担心, 通过使用二维码, 他们不会像以前那样得到那么多小费.” Shinya Ramen 的老板 Joey 告诉我们, “这种担忧很快就被打消了.
      我们的平均小费百分比提高了近35%, 因为服务员们现在可以专注于客人需要什么并且与客人建立友好关系.”`,
        en: `By adopting contactless QR code ordering, Shinya Ramen increased the table turnover rate by 30% and was able to cut two more headcounts. 
      “Some of our waiters and waitresses worry that by using QR code,  they would not get as much as tips as before. "Shinya Ramen's co-owner Joey told us,  
      “The concern was quickly dispelled. Our average tip percentage was increased almost 35% because waiters and waitresses can now focus on table  
      touching and making personal connections with the guests."`,
      },
      restaurantName: { zh: '深夜食堂', en: 'Shinya Ramen' },
      location: { zh: '芝加哥', en: 'Chicago, IL' },
      link: '/business-types/sushi-ramen/shinya-ramen-house',
    },
  ],
};

export default SectionContent;
